import { useState, useMemo, useCallback, useRef } from "react";

const usePersistedFilters = (key, initialFilters = {}) => {
  const initialRef = useRef(initialFilters);

  const [filters, setFilters] = useState(() => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : initialFilters;
    } catch {
      return initialFilters;
    }
  });

  const handleFilterChange = useCallback((field, value) => {
    setFilters((prev) => {
      const updated = { ...prev, [field]: value };
      sessionStorage.setItem(key, JSON.stringify(updated));
      return updated;
    });
  }, [key]);

  const clearFilters = useCallback(() => {
    setFilters(initialRef.current);
    sessionStorage.removeItem(key);
  }, [key]);

  const hasActiveFilters = useMemo(() => {
    return Object.entries(filters).some(([filterKey, value]) => {
      if (value === "" || value === null || value === undefined) return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "object" && value !== null) return Object.keys(value).length > 0;
      return value !== initialRef.current[filterKey];
    });
  }, [filters]);

  return { filters, setFilters, handleFilterChange, clearFilters, hasActiveFilters };
};

export default usePersistedFilters;
